export default __webpack_public_path__ + "static/media/ResizePage.b93864d5.png";